import { useEffect, useState } from "react";
import {
  Tooltip,
  Typography,
  Button,
  Radio,
  Avatar,
  useToast,
  Modal,
  Box,
} from "fds";
import WorkgroupAvatar from "../../components/WorkgroupAvatar";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Workgroup } from "../../types/workgroup";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import { t } from "i18next";
import { nanoid } from "@reduxjs/toolkit";

interface SelectDocShareChildrenProps {
  open: boolean;
  currentWorkgroupInfo?: Workgroup;
  onClose: () => void;
}
const MoveWorkgroupModal: React.FC<SelectDocShareChildrenProps> = ({
  open,
  currentWorkgroupInfo,
  onClose,
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";
  const companyName =
    window.eco.serviceType === "OCI"
      ? t("admin.filter.userInternal")
      : loginDto
      ? loginDto.ecoCommonConfig?.companyName
      : "COMPANY";
  const toasts = useToast();
  const { workgroupState, moveWorkgroup, getWorkgroupSideList } =
    useWorkgroupStore();
  const [workgroupList, changeWorkgorupList] = useState([]);
  const [targetWorkgroupId, changeTargetWorkgroupId] = useState<
    string | undefined
  >(undefined);
  useEffect(() => {
    /** 타겟 워크그룹 정의
     * 1. Root 이거나
     * 2. 내가 워크그룹장일것
     * 3. 현재 워크그룹의 바로 바로 상단 워크그룹이 아닐것
     * 4. 현재 워크그룹의 하단 워크그룹이 아닐것
     * 5. 비공개 본체 또는 하위가 아닐것
     */
    const descentdantWorkgroupList = [currentWorkgroupInfo?.workgroupId];
    const remainWorkgroupList = [currentWorkgroupInfo?.workgroupId];
    while (remainWorkgroupList.length > 0) {
      const targetWorkgroupId = remainWorkgroupList.pop();
      workgroupState.workgroupSidemenuList
        ?.filter(
          (item: Workgroup) => item.parentWorkgroupId === targetWorkgroupId
        )
        .forEach((item: Workgroup) => {
          remainWorkgroupList.push(item.workgroupId);
          descentdantWorkgroupList.push(item.workgroupId);
        });
    }
    changeWorkgorupList(
      workgroupState.workgroupSidemenuList?.filter(
        (item: Workgroup) =>
          item.managerId === myId &&
          item.workgroupId !== currentWorkgroupInfo?.parentWorkgroupId &&
          item.workgroupType === "GENERAL" &&
          !descentdantWorkgroupList.includes(item.workgroupId)
      )
    );
  }, [workgroupState.workgroupSidemenuList]);
  const handleMoveWorkgroup = async () => {
    if (!currentWorkgroupInfo) return;
    let resp = await moveWorkgroup(
      currentWorkgroupInfo?.workgroupId,
      targetWorkgroupId ?? ""
    );
    if (resp.payload) {
      getWorkgroupSideList({
        isDetail: "Y",
        managerId: "",
        orderBy: "workgroupName",
        orderByType: "ASC",
        pageRange: 1,
        posPage: 1,
        rowRange: 0,
        searchDate: { start: 0, end: 0 },
        status: 1,
        workgroupName: "",
        noSaveConfig: true,
      });
      toasts.toastMsg(nanoid(), t("workgroup.alert.moveSuccess"), "success");
    } else {
      toasts.toastMsg(nanoid(), t("workgroup.alert.moveFail"), "error");
    }
    onClose();
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("workgroup.moveWorkgroup")}
      width={540}
      subTitle={t("workgroup.moveWorkgroupDesc")}
      footer={
        <Box>
          <Button
            label={t("common.cancel")}
            type="secondary"
            btnStyle="fill"
            onClick={onClose}
          />
          <Button
            label={t("common.move")}
            type="primary"
            btnStyle="fill"
            state={targetWorkgroupId === undefined ? "disable" : "default"}
            onClick={handleMoveWorkgroup}
          />
        </Box>
      }
      body={
        <Box
          height={403}
          direction="column"
          style={{ overflow: "auto", padding: "0 8px" }}
        >
          {currentWorkgroupInfo?.parentWorkgroupId !== null && (
            <Box alignItems="center" width={"100%"} minHeight={48}>
              <Avatar
                uniqueCode={"2"}
                icon="team"
                shape="workgroup"
                size={"32"}
                classes="mg mr-8"
              />
              <Tooltip
                hideToolTip
                classes="mg mr-auto"
                maxWidth={"calc(100% - 75px)"}
              >
                <Typography ellipsis>
                  {t("workgroup.moveIndependent")}
                </Typography>
              </Tooltip>
              <Radio
                check={targetWorkgroupId === ""}
                onClick={() => changeTargetWorkgroupId("")}
              />
            </Box>
          )}
          {workgroupList.map((item: Workgroup) => (
            <Box alignItems="center" width={"100%"} minHeight={48}>
              <WorkgroupAvatar item={item} size={"32"} classes="mg mr-8" />
              <Tooltip
                message={item.workgroupName}
                classes="mg mr-auto"
                maxWidth={"calc(100% - 75px)"}
              >
                <Typography ellipsis>{item.workgroupName}</Typography>
              </Tooltip>
              <Radio
                check={targetWorkgroupId === item.workgroupId}
                onClick={() => changeTargetWorkgroupId(item.workgroupId)}
              />
            </Box>
          ))}
        </Box>
      }
    />
  );
};
export default MoveWorkgroupModal;
